import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { useStyletron } from "baseui";
import { Modal, ModalHeader, ModalBody, SIZE } from "baseui/modal";
import { StatefulDataTable, StringColumn } from "baseui/data-table";

const InspectionsModal = ({ isOpen, handleModalClose, rowData }) => {
  console.log("rowData:", rowData);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [css] = useStyletron();
  const [inspectionData, setInspectionData] = useState([]);
  const [stepsMap, setStepsMap] = useState([]); //step_name strings
  const [userMap, setUserMap] = useState({}); //user 'first_name + last_name' strings
  // const [inventoryMap, setInventoryMap] = useState([]);
  const hasFetchedRef = useRef(false);

  const inventoryString = `${rowData.year} ${rowData.make} ${rowData.model}`;

  const createUserMap = (usersData) => {
    return usersData.reduce((map, user) => {
      map[user.id] = `${user.first_name} ${user.last_name}`;
      return map;
    }, {});
  };
  const createStepsMap = (steps) => {
    return steps.reduce((map, step) => {
      map[step.id] = `${step.step_name}`;
      return map;
    }, {});
  };

  const fetchInspectionStepsUserData = useCallback(async () => {
    try {
      const [inspectionsResponse, usersResponse, stepsResponse] =
        await Promise.all([
          axios.get(`${apiUrl}/api/inspections`),
          axios.get(`${apiUrl}/api/users/list`),
          axios.get(`${apiUrl}/api/steps`),
        ]);

      setInspectionData(inspectionsResponse.data);
      setUserMap(createUserMap(usersResponse.data.users));
      setStepsMap(createStepsMap(stepsResponse.data.steps));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchInspectionStepsUserData();
  }, [fetchInspectionStepsUserData]);

  // console.log("inspectionData", inspectionData);
  // console.log("userMap", userMap);
  // console.log("stepsMap", stepsMap);

  const locationMap = {
    S01_Holmes1: "Diberville",
    S05_Montgomery1: "Montgomery",
    S07_Bham1: "Birmingham",
    S09_Douglas1: "Douglasville",
  };

  const formatLocation = (locationString) => {
    return locationMap[locationString] || "Unknown Location";
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const time = `${hours}:${minutes}${ampm}`;
    return `${month}-${day}-${year}, ${time}`;
  }

  const createRows = (inspectionData) => {
    const filteredInspectionData = inspectionData.filter(
      (inspection) => inspection.inventory_id === rowData.id
    );

    return filteredInspectionData.map((inspection) => ({
      id: inspection.id,
      data: [
        formatDate(inspection.inspection_date),
        userMap[inspection.inspector_id] || "Unknown",
        inspection.stock,
        inventoryString,
        // inventoryMap[inspection.inventory_id] || "Unknown",

        formatLocation(inspection.location),
        stepsMap[inspection.step_id] || "Unknown",
        inspection.description,
        stepsMap[inspection.next_status] || "Unknown",
      ],
    }));
  };

  const rows = createRows(inspectionData);

  const columns = [
    StringColumn({
      title: "Date",
      // mapDataToValue: (rowData) => formatDate(rowData.date),
      mapDataToValue: (data) => data[0],
    }),
    StringColumn({
      title: "Inspector",
      mapDataToValue: (data) => data[1],
    }),
    StringColumn({
      title: "Stock",
      mapDataToValue: (data) => data[2],
    }),
    StringColumn({
      title: "Vehicle",
      mapDataToValue: (data) => data[3],
    }),
    StringColumn({
      title: "Location",
      mapDataToValue: (data) => data[4],
    }),
    StringColumn({
      title: "Inspection Type",
      mapDataToValue: (data) => data[5],
    }),
    StringColumn({
      title: "Description",
      mapDataToValue: (data) => data[6],
    }),
    StringColumn({
      title: "Next Status",
      mapDataToValue: (data) => data[7],
    }),
  ];
  return (
    <Modal
      size={SIZE.full}
      isOpen={isOpen}
      closeable
      onClose={handleModalClose}
    >
      <ModalHeader>
        Inspections for {rowData.year} {rowData.make} {rowData.model}
      </ModalHeader>
      <ModalBody>
        <div
          className={css({
            height: "82vh",
            // width: "800px",
            display: "flex",
            flexDirection: "column",
          })}
        >
          {rows.length > 0 ? (
            <StatefulDataTable columns={columns} rows={rows} />
          ) : (
            <h2> No inspections found</h2>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default InspectionsModal;
